"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownExperimentalLayoutFooterRow = void 0;

var _context = require("../../../context");

var _layout = require("../../../layout");

var _utils = require("../../../utils");

var DropdownExperimentalLayoutFooterRow = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    borderTop: "1px solid ".concat(selectors.color('neutral20')),
    padding: (0, _utils.px)(selectors.space('S300'))
  };
});
exports.DropdownExperimentalLayoutFooterRow = DropdownExperimentalLayoutFooterRow;